import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ allow, children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-parchment text-forest">
        <span className="text-sm tracking-[0.3em] uppercase text-moss">Memuat…</span>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (allow && !allow.includes(user.role)) {
    // logged in but wrong role → send to their own dashboard
    const dest = user.role === "admin" ? "/admin" : user.role === "pembimbing" ? "/pembimbing" : "/santri";
    return <Navigate to={dest} replace />;
  }
  return children;
}
